const AccountType = {
    USER: 0,
    MODERATOR: 1,
    ADMIN: 2,
    SUPERADMIN: 3,
};

const AccountStatus = {
    ACTIVE: 0,
    INACTIVE: 1,
    BLOCKED: 2,
    EMAIL_NOT_VERIFIED: 3,
};

const BadgeStatus = {
    ACTIVE: 0,
    INACTIVE: 1,
};

const FilterStatus = {
    ACTIVE: 0,
    INACTIVE: 1,
};

const FilterGroup = {
    SEARCH: 1 << 0,
    TRENDING: 1 << 1,
    ADMIN: 1 << 2,
    RECOMMEND: 1 << 3,
    EXPLORE: 1 << 4,
};

// Marks a filter_option whose content is dynamically generated by a scheduler job.
// Each bit = the job that owns/regenerates this option's content (e.g. the trending
// scheduler fills options flagged TRENDING with its bucket subkeys).
const FilterOptionAttribute = {
    TRENDING: 1 << 0,
};

const MessageTag = {
    NONE: 1 << 0,
    UNREAD: 1 << 1,
    EXPIRING: 1 << 2,
};

const PostStatus = {
    ACTIVE: 0,
    INACTIVE: 1,
    BLOCKED: 2,
    CENSORED: 3,
    PROCESSING: 4,
};

const ReportStatus = {
    PENDING: 0,
    RESOLVED: 1,
    DISMISSED: 2,
    DELETED: 3,
};

const UserBlockExpires = {
    DAY_1: 1,
    DAY_3: 3,
    DAY_5: 5,
    DAY_7: 7,
    DAY_14: 14,
    DAY_28: 28,
};

const UserBlockReasons = {
    MAX_FOLLOWING_HIT: 0,
    MAX_CHATMESSAGE_HIT: 1,
    FAKE_PROFILE_OR_SCAMMER: 2,
    FAKE_OR_AI_GENERATED_PHOTO: 3,
    NUDITY_OR_SEXUALLY_EXPLICIT: 4,
    NOT_A_PHOTO_OF_THIS_USER: 5,
};

const UserButtonState = {
    NONE: 0,
    FOLLOW: 1,
    UNFOLLOW: 2,
    CHAT: 3,
};

const UserStatus = {
    ACTIVE: 0,
    INACTIVE: 1,
    INVISIBLE: 2,
    BLOCKED: 3,
    NOT_VERIFIED: 4,
};

// Service-scoped role, independent of AccountType. ADMIN users are hidden from discovery
// (search, explore, trending, user lists) but stay reachable by direct profile link.
const UserType = {
    USER: 0,
    ADMIN: 1,
};

const UserTag = {
    NONE: 1 << 0,
    NEW: 1 << 1,
    TRENDING: 1 << 2,
};

export {
    AccountStatus,
    AccountType,
    BadgeStatus,
    FilterGroup,
    FilterOptionAttribute,
    FilterStatus,
    MessageTag,
    PostStatus,
    ReportStatus,
    UserButtonState,
    UserStatus,
    UserBlockExpires,
    UserBlockReasons,
    UserTag,
    UserType,
};
